import {Box, Text, TextAlign, ThemeColorTextPath} from 'platform/foundation';

import {EMPTY_PLACEHOLDER} from '@dms/shared';

import {Nullish} from 'shared/web';

interface MazdaDetailTableTextCellProps {
  value: string | Nullish;
  color?: ThemeColorTextPath;
  align?: TextAlign;
}

export function MazdaDetailTableTextCell(props: MazdaDetailTableTextCellProps) {
  return (
    <Box paddingHorizontal={4} paddingVertical={2}>
      <Text size="small" color={props.color} align={props.align}>
        {props.value ?? EMPTY_PLACEHOLDER}
      </Text>
    </Box>
  );
}
